import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline, secondaryFill, secondaryOutline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M73.781 41.49C73.781 41.49 60.221 34.6 56.171 29.87C51.671 24.61 51.871 1.96997 51.871 1.96997H39.451C39.451 1.96997 39.761 24.72 35.151 29.87C30.261 35.33 17.541 41.29 17.541 41.29C23.731 55.87 36.131 59.59 45.661 59.59C55.201 59.59 67.591 56.08 73.781 41.49Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M87.311 58.39C85.751 46.38 82.101 43.1399 77.431 40.7899C75.131 39.6299 60.6111 31.9099 60.6111 31.9099C60.6111 31.9099 55.7011 38.8499 46.0211 38.8499C36.3411 38.8499 30.721 31.9099 30.721 31.9099C30.721 31.9099 16.281 39.5799 13.881 40.7899C9.21104 43.1399 5.65104 46.77 4.00104 58.39C2.52104 69.45 2.08105 72.21 2.08105 72.21H89.231C89.231 72.21 88.621 68.69 87.311 58.39Z"
        fill={secondaryFill}
        stroke={secondaryOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M24.7715 34.72C24.7715 34.72 31.0215 44.96 44.7515 44.96C59.9415 44.96 66.5515 34.72 66.5515 34.72"
        stroke={secondaryOutline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M40.5608 33.3L41.6608 30.55L33.6208 25.49C33.6208 25.49 32.6608 27.22 30.7608 29.29C29.3108 30.87 27.5208 32.51 24.0408 34.46C20.4108 36.5 16.0808 38.55 12.8108 40.57C8.84076 43.02 6.02078 45.98 4.33078 52.96C3.01078 58.41 1.30078 72.23 1.30078 72.23H40.0008L40.5608 33.3Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M50.7613 33.88C50.7613 33.88 49.4113 33.9 49.0313 32.64C48.6213 31.28 49.6613 30.55 49.6613 30.55L57.7013 25.49C57.7013 25.49 58.6613 27.22 60.5613 29.29C62.0113 30.87 63.8013 32.51 67.2813 34.46C70.9113 36.5 75.2413 38.55 78.5113 40.57C82.4813 43.02 85.3012 45.98 86.9912 52.96C88.3112 58.41 90.0213 72.23 90.0213 72.23H51.3213L50.7613 33.88Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="M51.3008 33.34L59.2208 28.3101" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M40.0206 33.8L32.1006 28.76" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M6.01074 46.6699L13.5707 72.4299"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M5.18066 49.3101L11.6207 71.55"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M18.6211 71.8099V63.8398H33.5111V71.9599"
        fill={fill}
        stroke={outline}
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M85.381 46.78L78.041 72.48"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M85.9413 50.25L79.5312 73.14"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M72.9906 71.8099V63.8398H58.1006V71.9599"
        fill={fill}
        stroke={outline}
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M50.9209 32.3999C51.197 32.3999 51.4209 32.176 51.4209 31.8999C51.4209 31.6238 51.197 31.3999 50.9209 31.3999C50.6448 31.3999 50.4209 31.6238 50.4209 31.8999C50.4209 32.176 50.6448 32.3999 50.9209 32.3999Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.659"
          y1="43.1446"
          x2="45.659"
          y2="9.11187"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
